<template>
  <vl-action-group>
    <vl-button
      v-if="canDelete"
      :mod-disabled="data.loading"
      :mod-loading="data.loading"
      icon="trash"
      mod-icon-before
      mod-error
      @click="confirmDelete"
    >
      {{ $t('general.delete') }}
    </vl-button>
    <vl-button icon="cross" mod-icon-before mod-secondary mod-error @click="cancelDelete">
      {{ $t('general.cancel') }}
    </vl-button>
  </vl-action-group>
</template>

<script lang="ts" setup>
import { useModalStore } from '@/modules/core/store/modal.store';
import { reactive } from 'vue';
import { computed } from 'vue';
import { RouteLocationRaw, useRouter } from 'vue-router';

export type PbsDeleteModalOptions = {
  canDelete?: boolean;
  navigationRouteOnSuccess?: RouteLocationRaw;
  confirm?: (e: any) => Promise<boolean>;
};

const modalStore = useModalStore();

const props = withDefaults(defineProps<PbsDeleteModalOptions>(), {
  canDelete: true,
  navigationRouteOnSuccess: null,
  confirm: null,
});

const data = reactive({
  loading: false,
});

const router = useRouter();

const canDelete = computed(() => props.canDelete);

const confirmDelete = async (e) => {
  if (props.confirm) {
    try {
      data.loading = true;
      const isSuccess = await props.confirm(e);
      if (isSuccess && props.navigationRouteOnSuccess) {
        router.push(props.navigationRouteOnSuccess);
      }
    } finally {
      data.loading = false;
    }
  }

  closeModal();
};

const cancelDelete = () => {
  closeModal();
};

const closeModal = () => {
  modalStore.hideModal();
};
</script>

<style lang="scss" scoped></style>
